import React from 'react';

export default function WazuhAlertList({ alerts, emptyText = 'No Wazuh alerts in range', maxHeight = 'max-h-56' }) {
  if (!alerts || alerts.length === 0) {
    return <div className="muted" style={{ fontSize: 12, padding: '16px 0', textAlign: 'center' }}>{emptyText}</div>;
  }
  const dotColor = (lvl) => Number(lvl) >= 10 ? 'var(--danger)' : Number(lvl) >= 7 ? '#fb923c' : '#facc15';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, overflowY: 'auto', maxHeight: maxHeight === 'max-h-56' ? 224 : undefined }}>
      {alerts.map((w, i) => (
        <div key={i} className="flex" style={{ alignItems: 'flex-start', gap: 12, padding: 10, borderRadius: 9, background: 'var(--glass)', border: '1px solid var(--glass-border)' }}>
          <span style={{ flexShrink: 0, width: 8, height: 8, marginTop: 4, borderRadius: '50%', backgroundColor: dotColor(w.rule_level) }} />
          <div style={{ minWidth: 0, flex: 1 }}>
            <div className="flex between" style={{ gap: 8 }}>
              <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-1)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{w.rule_description || 'Wazuh alert'}</span>
              <span className="mono muted" style={{ fontSize: 10, flexShrink: 0 }}>lvl {w.rule_level}</span>
            </div>
            <div className="mono muted" style={{ fontSize: 10, marginTop: 2 }}>
              {String(w.timestamp || '').replace('T', ' ').slice(0, 19)} · {w.agent_name || w.agent_ip || '-'}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
